export function formatDate(data: Date | null | undefined) {
    if (data === null || data === undefined) {
        return '';
    }
    return (new Date(data)).toLocaleString('nl-BE', {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
}

export function formatTime(data: Date | null) {
    if (data === null || data === undefined) {
        return '';
    }
    return (new Date(data)).toLocaleString('nl-BE', {
        hour: "2-digit",
        minute: "2-digit"
    });
}

export function formatColumnDateWithTime(data: string | null | undefined) {
    if (data === null || data === undefined) {
        return '';
    }
    return (new Date(data)).toLocaleString('nl-BE', {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
}

export function formatColumnDate(data: string | null | undefined) {
    if (data === null || data === undefined) {
        return '';
    }
    return (new Date(data)).toLocaleString('nl-BE', {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
}

export function displayBoolean(data: boolean | null) {
    if (data === null || data === undefined) {
        return '';
    }
    if (data === true) {
        return "Ja"
    }
    if (data === false) {
        return "Nee"
    }
}

export const groupBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) =>
    list.reduce((previous, currentItem) => {
        const group = getKey(currentItem);
        if (!previous[group]) previous[group] = [];
        previous[group].push(currentItem);
        return previous;
    }, {} as Record<K, T[]>);


export function convertBase64(file: Blob) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
            resolve(fileReader.result);
        }
        fileReader.onerror = (error) => {
            reject(error);
        }
    })
}